import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Device} from '../models/device';
import {deviceAvailableActionTypes, LoadDeviceAvailableSuccessAction, LoadDeviceAvailableUpdateAction} from '../actions/device-available';

export interface DeviceAvailableState {
  array: Device[];
}

const initialState: DeviceAvailableState = {
  array: []
};

export function DeviceAvailableReducer(state: DeviceAvailableState = initialState, action: Action): DeviceAvailableState {
  switch (action.type) {
    case deviceAvailableActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case deviceAvailableActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case deviceAvailableActionTypes.UPDATE:
      return handleUpdateAction(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: DeviceAvailableState, action: LoadDeviceAvailableSuccessAction): DeviceAvailableState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: DeviceAvailableState): DeviceAvailableState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

function handleUpdateAction(state: DeviceAvailableState, action: LoadDeviceAvailableUpdateAction): DeviceAvailableState {
  return {...state, ...{array: state.array.filter((device: Device) => device.name !== action.payload)}};
}

export const deviceAvailableSelectors = {
  array: (state: DeviceAvailableState) => _.get(state, 'array', [])
};
